import * as OpenReportingCreators from '../../../creators/OpenReporting.creators';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as React from 'react';
import { FormInput } from 'src/components/molecules';
import { FormInputVariant, FormState } from 'src/types';

import { LoginContainer } from './Login.styles';

interface UserAndPasswordInputProps {
  setLoginUsername(
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void;
  setLoginPassword(
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void;
  handleLogin: Function;
}

const UserAndPasswordInput = (props: UserAndPasswordInputProps) => {
  const { t } = useTranslation();
  return (
    <LoginContainer data-testid={'opr-login-container'}>
      <FormInput
        variant={FormInputVariant.INPUT}
        state={FormState.DEFAULT}
        label={t('public.CreatePublicReport.yourVaultId')}
        placeholder={t('public.CreatePublicReport.vaultIdPlaceholder')}
        onPaste={(
          event: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>,
        ) => props.setLoginUsername(event)}
        onChange={(
          event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        ) => props.setLoginUsername(event)}
        data-testid="user-email"
        type="text"
        tooltipText={t('public.CreatePublicReport.vaultIdTooltip')}
        tooltipWidth={'193px'}
      />
      <FormInput
        variant={FormInputVariant.INPUT}
        state={FormState.DEFAULT}
        label={t('public.CreatePublicReport.yourPassword')}
        data-testid="user-password"
        type="password"
        placeholder={t('public.CreatePublicReport.passwordPlaceholder')}
        onKeyDown={(e) => e.key === 'Enter' && props.handleLogin()}
        onChange={(
          event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        ) => props.setLoginPassword(event)}
      />
    </LoginContainer>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      ...OpenReportingCreators,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(UserAndPasswordInput);
